import { Quote } from "lucide-react";
import { testimonials } from "./content";

export default function TestimonialsSection() {
    return <section className="mz-section mz-section--soft" id="stories">
        <div className="mz-container">
            <p className="mz-section-label">Student Stories</p>
            <h2 className="mz-section-title">You're in good company.</h2>
            <p className="mz-section-lead">Students are building confidence through practical learning, guided experience and realistic evaluation.</p>
            <div className="mz-testimonial-grid">
                {testimonials.map((testimonial) => <article className="mz-testimonial" key={testimonial.name}>
                    <Quote aria-hidden="true" />
                    <p>“{testimonial.text}”</p>
                    <div><strong>{testimonial.name}</strong><span>{testimonial.role}</span></div>
                </article>)}
            </div>
        </div>
    </section>;
}
